import { all } from 'redux-saga/effects'
import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import rootReducers from '../../reducers'
import { fetchAfterExpiryTimeWatcher } from './ExTime.saga'
function* rootSaga() {
  yield all([
    fetchAfterExpiryTimeWatcher()
  ])
}

const sagaMiddleware = createSagaMiddleware()
const store = createStore(rootReducers, applyMiddleware(sagaMiddleware))

let lastCartItems = null;
store.subscribe(() => {
  const state = store.getState();
  const items = state.cartReducer?.items || [];
  if (items !== lastCartItems) {
    lastCartItems = items;
    try {
      localStorage.setItem('cartItems', JSON.stringify(items));
    } catch (e) {
      console.error('Failed to persist cart items to localStorage:', e);
    }
  }
});

export { sagaMiddleware, store, rootSaga }
